import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"grip.small\"><g id=\".fill\"><rect id=\"Rectangle 1\" x=\"5\" y=\"2\" width=\"4\" height=\"4\" rx=\"2\"></rect><rect id=\"Rectangle 3\" x=\"5\" y=\"14\" width=\"4\" height=\"4\" rx=\"2\"></rect><rect id=\"Rectangle 4\" x=\"5\" y=\"8\" width=\"4\" height=\"4\" rx=\"2\"></rect><rect id=\"Rectangle 5\" x=\"11\" y=\"2\" width=\"4\" height=\"4\" rx=\"2\"></rect><rect id=\"Rectangle 6\" x=\"11\" y=\"14\" width=\"4\" height=\"4\" rx=\"2\"></rect><rect id=\"Rectangle 7\" x=\"11\" y=\"8\" width=\"4\" height=\"4\" rx=\"2\"></rect></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }